@if (formDefinition$ | async; as formDefinition) {
  @if (initialized$ | async) {
    <form [formGroup]='dataForm'>
      <div class='dash-gis-data-form-field-container' fxLayout='column'>
        @for (field of formDefinition.fields; track field.dbFieldName) {
          @switch (field.uiType) {
            @case ('text') {
              <mat-form-field>
                <mat-label>{{field.displayName}}</mat-label>
                <input matInput type='text'
                  [formControlName]='field.fieldName'
                  [placeholder]='field.displayName'
                  [required]='field.required'
                  [name]='field.fieldName' />
                @if (dataForm.get(field.fieldName).hasError('pattern')) {
                  <mat-error>
                    {{ field.validationMessage }}
                  </mat-error>
                }
                @if (dataForm.get(field.fieldName).hasError('required')) {
                  <mat-error>
                    {{ field.displayName }} is required.
                  </mat-error>
                }
              </mat-form-field>
            }
            @case ('textarea') {
              <mat-form-field>
                <mat-label>{{field.displayName}}</mat-label>
                <textarea matInput cdkTextareaAutosize
                  [formControlName]='field.fieldName'
                  [placeholder]='field.displayName'
                  [required]='field.required'
                [name]='field.fieldName'></textarea>
                @if (dataForm.get(field.fieldName).hasError('pattern')) {
                  <mat-error>
                    {{ field.validationMessage }}
                  </mat-error>
                }
                @if (dataForm.get(field.fieldName).hasError('required')) {
                  <mat-error>
                    {{ field.displayName }} is required.
                  </mat-error>
                }
              </mat-form-field>
            }
            @case ('dropdown') {
              <ng-container *ngTemplateOutlet='dropdownTemplate; context: {field, dataForm}'></ng-container>
            }
            @case ('dropdown_multi') {
              @if (!field.parameter) {
                <mat-form-field>
                  <mat-label>{{field.displayName}}</mat-label>
                  <mat-select [formControlName]='field.fieldName'
                    [placeholder]='field.displayName'
                    [required]='field.required'
                    multiple
                    aria-label='{{field.displayName}}'>
                    @for (opt of field.dropdownItems; track opt.value) {
                      <mat-option
                        [value]='opt.value'>
                        {{ opt.text }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (dataForm.get(field.fieldName).hasError('required')) {
                    <mat-error>
                      {{ field.displayName }} is required.
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (!!field.parameter) {
                <mat-form-field>
                  <mat-label>{{field.displayName}}</mat-label>
                  <mat-select [formControlName]='field.fieldName'
                    [placeholder]='field.displayName'
                    [required]='field.required'
                    multiple
                    aria-label='{{field.displayName}}'>
                    @for (opt of getDropDownOptions$(field) | async; track opt.value) {
                      <mat-option
                        [value]='opt.value'>
                        {{ opt.text }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (dataForm.get(field.fieldName).hasError('required')) {
                    <mat-error>
                      {{ field.displayName }} is required.
                    </mat-error>
                  }
                </mat-form-field>
              }
            }
            @case ('date') {
              <mat-form-field>
                <mat-label>{{field.displayName}}</mat-label>
                <input matInput
                  [formControlName]='field.fieldName'
                  [placeholder]='field.displayName'
                  [required]='field.required'
                  [matDatepicker]='dataFormDatePicker'>
                <mat-datepicker-toggle matSuffix [for]='dataFormDatePicker'></mat-datepicker-toggle>
                <mat-datepicker #dataFormDatePicker></mat-datepicker>
                @if (isDateInvalid(field.fieldName)) {
                  <mat-error>
                    Invalid date format.
                  </mat-error>
                }
                @if (isDateRequiredAndMissing(field.fieldName)) {
                  <mat-error>
                    {{ field.displayName }} is required.
                  </mat-error>
                }
              </mat-form-field>
            }
            @case ('barcode') {
              <mat-form-field>
                <mat-label>{{field.displayName}}</mat-label>
                <input matInput type='text' #barcodeTarget
                  [formControlName]='field.fieldName'
                  [placeholder]='field.displayName'
                  [required]='field.required'
                  [name]='field.fieldName' />
                <dash-gis-barcode-scanner-button matSuffix
                [target]='dataForm.controls[field.fieldName]'></dash-gis-barcode-scanner-button>
                @if (dataForm.get(field.fieldName).hasError('pattern')) {
                  <mat-error>
                    {{ field.validationMessage }}
                  </mat-error>
                }
                @if (dataForm.get(field.fieldName).hasError('required')) {
                  <mat-error>
                    {{ field.displayName }} is required.
                  </mat-error>
                }
              </mat-form-field>
            }
            @case ('hidden') {
              <input type='hidden' [formControlName]='field.fieldName' />
            }
          }
        }
        @if (saveError$|async; as error) {
          <div class='mat-error'>{{ error.message }}</div>
        }
      </div>
    </form>
  }
}

<ng-template #dropdownTemplate let-field="field" let-form="dataForm">
  <ng-container [formGroup]='form'>
    @if (!field.parameter) {
      <mat-form-field>
        <mat-label>{{field.displayName}}</mat-label>
        <mat-select [formControlName]='field.fieldName'
          [placeholder]='field.displayName'
          [required]='field.required'
          aria-label='{{field.displayName}}'>
          <mat-option [value]='undefined'>-- Select --</mat-option>
          @for (opt of field.dropdownItems; track opt.value) {
            <mat-option
              [value]='opt.value'>
              {{ opt.text }}
            </mat-option>
          }
        </mat-select>
        @if (dataForm.get(field.fieldName).hasError('required')) {
          <mat-error>
            {{ field.displayName }} is required.
          </mat-error>
        }
      </mat-form-field>
    }


    @if (!!field.parameter) {
      <mat-form-field>
        <mat-label>{{field.displayName}}</mat-label>
        <mat-select [formControlName]='field.fieldName'
          [placeholder]='field.displayName'
          [required]='field.required'
          aria-label='{{field.displayName}}'>
          <mat-option [value]='undefined'>-- Select --</mat-option>
          @for (opt of getDropDownOptions$(field) | async; track opt.value) {
            <mat-option
              [value]='opt.value'>
              {{ opt.text }}
            </mat-option>
          }
        </mat-select>
        @if (dataForm.get(field.fieldName).hasError('required')) {
          <mat-error>
            {{ field.displayName }} is required.
          </mat-error>
        }
      </mat-form-field>
    }
  </ng-container>
</ng-template>
